package com.kinoshazam.di

import org.koin.core.module.Module
import org.koin.dsl.module

actual fun coreModule(): Module = module {
    common()
}